"use client";

import React from "react";
import { Activity, Gauge, Flame, ChartLine as LineChart } from 'lucide-react';
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface PrincipleItem {
  icon: React.ElementType;
  text: string;
}
const principles: PrincipleItem[] = [{
  icon: Activity,
  text: "We measure fitness — We don't guess your lifespan."
}, {
  icon: Gauge,
  text: "We assess movement — We don't create fictional biological ages."
}, {
  icon: Flame,
  text: "We measure metabolism — We don't promise rapid weight loss."
}, {
  icon: LineChart,
  text: "We track change — We don't guarantee outcomes."
}];
export default function StatementBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="scientificstatementbanner" ref={ref} data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 overflow-hidden border-y border-border">
      {/* Background clinical grid accent */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(var(--border)_1px,transparent_1px)] [background-size:24px_24px] opacity-40" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Statement Header */}
        <div className={`max-w-3xl mx-auto text-center mb-14 md:mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-foreground">
            Longevity without guesswork or gimmicks
          </h2>
          <p className="mt-4 text-lg md:text-xl text-muted-foreground font-normal leading-relaxed">
            PhysAnalytica focuses on measurements that have a clear physiological or functional meaning.
          </p>
        </div>

        {/* Four Principles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {principles.map((item, index) => {
          const Icon = item.icon;
          const parts = item.text.split(" — ");
          const positiveStatement = parts[0];
          const contrastStatement = parts[1];
          return <Card key={index} data-index={index} className={`border border-border/80 bg-card/90 shadow-xs hover:border-primary/40 transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            transitionDelay: isVisible ? `${index * 120}ms` : "0ms"
          }}>
                <CardContent className="p-6 md:p-8 flex items-start gap-4 sm:gap-5">
                  <div className="size-11 sm:size-12 rounded-lg bg-secondary flex items-center justify-center shrink-0 text-primary border border-border">
                    <Icon className="size-5 sm:size-6" aria-hidden="true" />
                  </div>
                  <div className="flex-1 space-y-1.5">
                    <p className="text-base sm:text-lg font-medium text-foreground tracking-tight">
                      {positiveStatement}
                    </p>
                    {contrastStatement && <p className="text-sm sm:text-base text-muted-foreground">
                        {contrastStatement}
                      </p>}
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}